/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { Link } from 'react-router';
import { useI18n } from '@/context/I18nContext';

export interface DashboardBreadcrumbItem {
    label: string;
    to?: string;
}

interface DashboardBreadcrumbProps {
    className?: string;
    items: DashboardBreadcrumbItem[];
}

function DashboardBreadcrumb({ className, items }: DashboardBreadcrumbProps) {
    const { t } = useI18n();
    const lastItemIndex = items.length - 1;

    return (
        <nav
            className={`breadcrumbs app-navbar__breadcrumb${className ? ` ${className}` : ''}`}
            aria-label={t('Breadcrumb')}
        >
            <ul>
                {items.map((item, index) => {
                    const isLastItem = index === lastItemIndex;

                    return (
                        <li key={`${item.label}-${index}`}>
                            {item.to && !isLastItem ? (
                                <Link className="app-navbar__breadcrumb-link" to={item.to}>
                                    {item.label}
                                </Link>
                            ) : (
                                <span className="app-navbar__breadcrumb-current">
                                    {item.label}
                                </span>
                            )}
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}

export default DashboardBreadcrumb;
